<template>
  <div :class="[baseCss, setBgColor(), setTextColor(), `shadow-${elevation}`]">
    <table-layout :y-align="contentYAlign">
      <row>
        <cell v-if="$slots.avatar" x-align="center">
          <slot name="avatar" />
        </cell>
        <cell :x-align="contentXAlign">
          <slot />
        </cell>
        <cell v-if="$slots.icon" x-align="center">
          <slot name="icon" />
        </cell>
      </row>
    </table-layout>
    <container v-if="$slots.actions" :class="[`text-${actionsXAlign}`]">
      <slot name="actions" />
    </container>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Banner',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('banner', [])
    }
  },
  props: {
    bgColor: {
      type: String,
      default: 'transparent'
    },
    bgColorLightness: {
      type: Number,
      default: null
    },
    color: {
      type: String
    },
    colorLightness: {
      type: Number,
      default: null
    },
    elevation: {
      type: String,
      default: 'none',
      validator: value => {
        return ['sm', 'md', 'lg', 'xl', '2xl', 'inner', 'none'].includes(value)
      }
    },
    contentYAlign: {
      type: String,
      default: 'middle',
      validator: value => {
        return ['top', 'middle', 'bottom', 'baseline', 'auto'].includes(value)
      }
    },
    actionsXAlign: {
      type: String,
      default: 'right',
      validator: value => {
        return ['left', 'center', 'right', 'auto'].includes(value)
      }
    },
    contentXAlign: {
      type: String,
      default: 'auto',
      validator: value => {
        return ['left', 'center', 'right', 'auto'].includes(value)
      }
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/banner/banner.vue